import Vue from 'vue'
import axios from 'axios'
import _ from 'lodash'
import { Toast } from 'vant'
// import store from '@/store'
import qs from 'querystringify'
import { router } from '@/plugins/vue-router'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})

// 取消请求白名单 切片上传接口等
const whiteList = []
// 取消重复请求
let pending = []

// 移除请求队列
function removePending(config) {
  for (let p in pending) {
    let configBase = ''
    if (config.url.indexOf(config.baseURL) == -1) {
      configBase = config.baseURL
    }
    if (config.baseURL + pending[p].u === configBase + config.url + '&' + config.method) {
      pending.splice(p, 1)
    }
  }
}
// 推入请求队列
function addPending(config) {
  const { url, method } = config
  // 如果是白名单接口 不存入pending
  for (let i = 0; i < whiteList.length; i++) {
    if (whiteList[i].indexOf(url) != -1) {
      return
    }
  }
  pending.push({ u: url + '&' + method })
}

// 判断请求是否存在
let cutReq = (config) => {
  const { url, method } = config
  for (let p in pending) {
    if (pending[p].u === url + '&' + method) {
      return true
    }
  }
}

// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent
    const { method, data, contentType, url } = config
    let flag = cutReq(config)
    // 存在相同请求
    if (flag === true) {
      if (url != '/common/uploadOss' || url.indexOf('/userInsuranceList/getInfoByUserIdCard/') != 0) {
        // 不是上传接口
        // throw error 中断请求
        throw new Error('cancelRequest')
      }
    }
    // 存入请求队列
    addPending(config)
    // parse data
    if (contentType === 'json') {
      config.headers['Content-Type'] = 'application/json'
    } else if (method !== 'get' && _.isObject(data)) {
      if (typeof config.headers['Content-Type'] === 'undefined') {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        config.data = qs.stringify(data)
      }
    }
    if (sessionStorage.getItem('Authorization')) {
      config.headers['Authorization'] = sessionStorage.getItem('Authorization')
    }
    config.headers['Clientid'] = '428a8310cd442757ae699df5d894f051' // 移动端固定标识
    return config
  },
  (error) => {
    console.log(error, 'error')
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data
    // const res = response
    // 请求完成把当前请求移除队列
    removePending(response.config)

    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 200) {
      // if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
      //   // to re-login
      // }
      if (res.code == 401) {
        Toast('登录过期请重新登录')
        sessionStorage.removeItem('X-Authorization')
        sessionStorage.removeItem('Authorization')
        sessionStorage.removeItem('idcard')
        setTimeout(() => {
          if (router.currentRoute.path.indexOf('/team') != -1) {
            router.replace('/team/team-login')
          } else {
            router.replace('/login')
          }
        }, 1000)
      }
      if (res.code == 510) {
        return Promise.reject(res)
      } else {
        if (res.code == 500) {
          return Promise.reject(res.msg)
        }
        return Promise.reject(new Error(res.msg || res.message || 'Error'))
      }
    } else {
      return res
    }
  },
  (error) => {
    // 中断请求 throw 的错误会来到这里 需要排除throw当前错误.
    if (error.message != 'cancelRequest') {
      console.log('err' + error)
      return Promise.reject(error)
    }
  }
)
Vue.$request = service
export default service
